import * as React from 'react';
import { useRecommendedPackagesPaymentStatus } from './hooks';
import { RecommendedPackagesPaymentStatus } from './RecommendedPackagesPaymentStatus';

export const RecommendedPackagesPaymentStatusContainer = () => {
  const { isRender, isMobile, status, handleRetryClick } = useRecommendedPackagesPaymentStatus();

  if (!isRender || !status) {
    return null;
  }

  return <RecommendedPackagesPaymentStatus status={status} isMobile={isMobile} handleRetryClick={handleRetryClick} />;
};
